<template>
  <div id="fullpage">
    <!-- Map Area Starts -->
    <section class="map-area section-padding fangan_section1 section">
      <div class="banner-sun">
        <p class="p1 animate fadeInDown animated jjfangan_zt1"
          style="animation-duration: 1s; animation-delay: 0.1s; visibility: visible;">解决方案</p>
        <p class="p2 animate zoomIn animated jjfangan_zt2"
          style="color: #e40230;animation-duration: 1s; animation-delay: 1s; visibility: visible;  color: #E91E63;">
          SOLUTION</p>
        <!-- <P class="p3 animate fadeInUp animated jjfangan_zt3"
          style="animation-duration: 1s; animation-delay: 0.3s; visibility: visible;">烟台拿度智能科技有限公司</P> -->
      </div>
      <div class="animate bounce animated"
        style="width: 100%; height: 100px; line-height: 100px; text-align: center;animation-duration: 1s; animation-delay: 1s; visibility: visible;">
        <img src="/static/assets/images/shubiao.png" />
      </div>
    </section>
    <!-- Map Area End -->
    <!-- 合作伙伴 starts -->

    <section class="section-padding8 section genghuanbeijing"
      style="background: url('../static/assets/images/fengdian.jpg')no-repeat center; background-size: 100% 100%;">
      <div class="container diannao_fangan" style="display:none;">
        <div class="row" style="line-height: 30px;font-weight: bold;">
          <div style="width: 35%;
    position: absolute;
    padding: 30px 80px;
    font-size: 14px;
    float: left;
    background: rgba(255, 255, 255, 0.76);
    border-radius: 10px;
    left: 20px;
    bottom: 2%;">
            {{ fanganinfo.def1 }}
          </div>
          <div style="width: 80%; padding-bottom: 50px;  font-size: 14px; position: absolute;  top: 80px;">
            <div style="        width: 45%;
    position: absolute;
    right: -11%;
    top: -65px;
    background: rgba(255, 255, 255, 0.76);
    padding: 30px 80px;
    border-radius: 10px;">{{ fanganinfo.def2 }}</div>
          </div>
        </div>
      </div>


      <div class="container shouji_fangan" style="display:none; padding: 25px;">
        <div class="row"
          style="line-height: 30px;font-weight: bold;background: #ffffff2e; padding: 10px; color: #ffffff; border-radius: 10px; top:9%;width: 95%; height:80% ; position: absolute; ">
          <div style="width: 100%;padding-bottom: 0px;font-size: 14px;">
            {{ fanganinfo.def1 }}
          </div>
          <div style="width: 100%; padding-bottom: 0px;  font-size: 14px;">
            {{ fanganinfo.def2 }}
          </div>
        </div>
      </div>
    </section>

    <!-- 合作伙伴 end -->

    <section class="blog-posts-area section-padding section sj_qhone">
      <div class="shojikak sj_qiehuan" >
        


        <div class="chanpin_s2 diannao_fangan1"  style="margin-bottom: 50px;">

          <div v-for="(item, index) in fanganlist" :key="index" class="chanpin_s1_02  animate zoomIn animated"
            style="animation-duration: 1s; animation-delay: 1s;">
            <a :href="'/jiejueinfo?id=' + item.id" target="_blank" style="color: black;">
              <div class="chanpin_s101_a" style="border-radius:0px;border: 0px">
                <div
                  :style="'background: url(' + newurl + item.ico + ')no-repeat center center;width: 100%;height: 200px;'">
                </div>
                <div class="tiaozhuan001" style="height: 130px;width: 100%;background: #ffffff;padding: 7px;">
                  <h4 class="xinwen">{{ item.title }}</h4>
                  <p style="font-size: 16px;color: #666666;">{{ truncatecontent(item.description) }}...</p>
                  <p class="tiaozhuan002"><span
                      style="float: right;border: 1px solid #cccccc;padding: 5px 20px; border-radius: 20px;">Details
                    </span></p>
                </div>
              </div>
            </a>
          </div>


        </div>

        <div class="chanpin_s2 shouji_fangan1">

          <!-- <div v-for="(item, index) in fanganlist.filter((_, i) => i < 2)" :key="index"
            class="chanpin_s1_02  animate zoomIn animated" style="animation-duration: 1s; animation-delay: 1s;"> -->
          <div v-for="(item, index) in fanganlist" :key="index"
            class="chanpin_s1_02  animate zoomIn animated" style="animation-duration: 1s; animation-delay: 1s;">
            <a :href="'/jiejueinfo?id=' + item.id" target="_blank" style="color: black;">
              <div class="chanpin_s101_a" style="border-radius:0px;border: 0px">
                <div
                  :style="'background: url(' + newurl + item.ico + ')no-repeat center center;width: 100%;height: 80px;'">
                </div>
                <div style="height: 70px;width: 100%;background: #ffffff;padding: 7px;">
                  <h4>{{ item.title }}</h4>
                  <p style="font-size: 16px;color: #666666;">{{ truncatecontentb(item.description) }}...</p>
                  <!-- <p><span style="float: right;border: 1px solid #cccccc;padding: 5px 20px; border-radius: 20px;">Details
                    </span></p> -->
                </div>
              </div>
            </a>
          </div>


        </div>



        <div class="row justify-content-between shouji_fangan1" style="width: 90%; margin-left: 5%;">
          <div class="col-sm-6 nav-left justify-content-start d-flex" style="width:40%;margin-top:20px ;">
            <div class="post-details" @click="qiehuanzus(page)">
              <p class="qiehuanzu">切换上一组</p>
            </div>
          </div>
          <div class="col-sm-6 nav-right justify-content-end d-flex" style="width:40%;margin-top:20px ;">
            <div class="post-details" @click="qiehuanzux(page)">
              <p class="qiehuanzu">切换下一组</p>
            </div>
          </div>
        </div>




        <div class="row justify-content-between diannao_fangan1" style="width: 90%; margin-left: 5%; height: 100px;">
          <div class="col-sm-6 nav-left justify-content-start d-flex qiehuan_shang">
            <div class="post-details" @click="qiehuanzus(page)">
              <p class="qiehuanzu">切换上一组</p>
            </div>
          </div>
          <div class="col-sm-6 nav-right justify-content-end d-flex qiehuan_xia">
            <div class="post-details" @click="qiehuanzux(page)">
              <p class="qiehuanzu">切换下一组</p>
            </div>
          </div>
        </div>




      </div>
    </section>
    <!-- Footer Area Starts -->
    <section class="footer-area section-padding9 section">
      <div class="footer-widget">
        <div class="container">
          <div class="row">

            <div class="col-xl-5 offset-xl-1 col-lg-6">
              <div class="single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd"
                style="animation-duration: 0.5s; animation-delay: 0.3s;">
                <h3 class="mb-4 phone_weibu_zt1" style="font-weight: 500;font-size: 40px;">专业技术团队 提供全方位系统解决方案</h3>
                <p class="mb-4" style="color: #7a7a7a;line-height: 60px;">如有任何疑问 请随时与我们联系</p>
                <form>

                  <input type="messname" v-model="messname" placeholder="您的姓名" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的姓名'" required>
                  <input type="messtel" v-model="messtel" placeholder="您的电话" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的电话'" required>
                  <input type="messtitle" v-model="messtitle" placeholder="您的留言" onfocus="this.placeholder = ''"
                    onblur="this.placeholder = '您的留言'" required>
                  <button type="submit" class="template-btnb" @click="buttonmess"
                    style="background: rgb(0 100 207);">立即提交</button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="footer-copyright weibu_sun">
        <div class="container" style="padding-top: 50px;">
          <div class="weibu_a">
            <img src="/static/assets/images/logob.png" />
            <div class="image-counter">
              <div class="image-containerc"></div>
              <div class="image-containera"></div>
              <div class="image-containerb"></div>
              <!-- <img src="/static/assets/images/weixin.png" style="width: 35px;height: 35px;">
    			<img src="/static/assets/images/douyin.png" style="width: 35px;height: 35px;">
    			<img src="/static/assets/images/weibo.png" style="width: 35px;height: 35px;"> -->
            </div>
          </div>
          <div class="weibu_b donghuasun" style="animation-duration: 0.6s; animation-delay: 0.4s;">
            <p>工业物联网整体解决方案服务商</p>
            <p>智能传感解决方案专家</p>
          </div>
          <div class="weibu_c donghuasun" style="animation-duration: 0.6s; animation-delay: 0.5s;">
            <p>{{ zhandianinfo.copyright }}</p>
            <p>总部公司 : {{ qiyeinfo.address }}</p>
            <p>服务热线 : {{ qiyeinfo.mobile }}</p>
            <p>主营产品 : {{ qiyeinfo.other }}</p>
            <p>{{ zhandianinfo.icp }} <i><img src="/static/assets/images/gongan.png"
                  style="width:16px; height:16px;margin-bottom: 5px;"></i></p>
          </div>
        </div>
      </div>



    </section>
    <!-- Footer Area End -->

  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      page: 1,
      qiyeinfo: [],
      zhandianinfo: [],
      daohanglist: [],
      messtel: '',
      messname: '',
      messtitle: '',
      fanganlist: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
      fanganinfo: [],
    }
  },
  mounted() {
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/company', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.qiyeinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //站点信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/site', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.zhandianinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //解决方案list
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/6/page/1', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.fanganlist = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });

    //解决方案
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/sort/scode/13', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        // console.log(response.data.data);
        this.fanganinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });





  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 16) {
      return dateStr.substring(0, length);
    },
    truncatecontentb(dateStr, length = 8) {
      return dateStr.substring(0, length);
    },
    //切换上一组
    qiehuanzus(pages) {
      console.log(pages)
      // return
      if (pages > 1) {
        var page = pages - 1;
      } else {
        var page = 1;
      }
      var that = this;
      this.page = page;




      //解决方案list
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/6/page/' + page, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          console.log(response.data);
          if (response.data.code == 1) {
            // that.page = pages+1;
            
            this.fanganlist = response.data.data;
          } else {
            this.fanganlist = response.data.data;
          }
          
          // this.fanganlist = response.data.data;

        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });
        // if(page==1){
        //     alert('当前已是首组');
        //   }
    },

    //切换下一组
    qiehuanzux(pages) {
      console.log(pages)
      // return
      var page = pages + 1;
      this.page = page;
      var that = this;
      //解决方案list
      axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/list/13/num/6/page/' + page, {
        appid: 'jurenkeji2024',
        timestamp: '1722845854',
        signature: '0eb76b812e96966c380b90c6e7416a26'
      })
        .then(response => {
          // console.log(response.data.data);
          // this.fanganlist = response.data.data;
          if (response.data.code == 0) {
            that.page = pages;
            alert('当前已是最后一组');

          } else {
            this.fanganlist = response.data.data;
          }

        })
        .catch(error => {
          console.error('当前网络环境异常!', error);
        });
    },

    //提交留言
    buttonmess() {
      // Message.success(`输入的内容是: ${this.messtitle}`);
      if (this.messname != '' && this.messtel != '' && this.messtitle) {
        // console.log('可以继续进行');
        // console.log('输入的内容是:', this.messname);
        // console.log('输入的内容是:', this.messtel);
        // console.log('输入的内容是:', this.messtitle);
        axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/cms/addmsg', {
          name: this.messname,
          tel: this.messtel,
          content: this.messtitle,
          appid: 'jurenkeji2024',
          timestamp: '1722845854',
          signature: '0eb76b812e96966c380b90c6e7416a26'
        })
          .then(response => {
            // console.log(response.data.data);
            // that.bannerlist = response.data.data;
            alert('留言提交成功!');
            this.messname = '';
            this.messtel = '';
            this.messtitle = '';
          })
          .catch(error => {
            console.error('当前网络环境异常!', error);
          });

      } else {
        alert('内容不能为空');
        return;
        // console.log('不能为空');
      }

    }

  }
}
</script>




// WEBPACK FOOTER //
// Fangan.vue?25890369